import { DataModel, DataModelBuilder, SerializationContext, SerializedData } from '../../dto/data-model.js';
import { MapUtils } from '../../../utility/map-utils.js';
import { isSameData } from '../../dto/data-model-utils.js';
import { Price } from '../price.js';
import { VersionRange } from '../../core/version-range.js';
import { Dayjs } from 'dayjs';
import { TimeZone } from '../../../time/timezone.js';

export class Refund extends DataModel {
  public static readonly TYPE_ID: string = 'e6cfa762b5f545f785cde6942a308855';
  public static readonly SCHEMA_VERSION: number = 1;

  private constructor(
    public readonly creatorId: string,
    public readonly creationDate: Dayjs,
    public readonly price: Price,
    public readonly comment: string | null,
  ) {
    super();
  }

  get $typeId(): string {
    return Refund.TYPE_ID;
  }

  get $schemaVersion(): VersionRange {
    return VersionRange.exactly(Refund.SCHEMA_VERSION);
  }

  static create(args: {
    creatorId: string,
    creationDate: Dayjs,
    price: Price,
    comment: string | null,
  }): Refund {
    return new Refund(
        args.creatorId,
        args.creationDate,
        args.price,
        args.comment
    );
  }

  static fromMap(context: SerializationContext, map: SerializedData): Refund {
    return new Refund(
        MapUtils.get<string>(map, 'creatorId'),
        TimeZone.decodeDate(MapUtils.get<number>(map, 'creationDate')),
        Price.decode(MapUtils.get<string>(map, 'price')),
        MapUtils.getOrNull<string>(map, 'comment'),
    );
  }

  toMap(context: SerializationContext): SerializedData {
    return {
      'creatorId': this.creatorId,
      'creationDate': TimeZone.encodeDate(this.creationDate),
      'price': this.price?.encode() ?? null,
      'comment': this.comment,
    };
  }

  clone(): this {
    return new Refund(
        this.creatorId,
        TimeZone.cloneDate(this.creationDate),
        this.price?.clone() ?? null,
        this.comment,
    ) as this;
  }

  isSame(other: this): boolean {
    if(other === this) {
      return true;
    }

    return isSameData(other.price, this.price) &&
        other.creatorId == this.creatorId &&
        other.creationDate == this.creationDate &&
        other.comment == this.comment;
  }
}

export class RefundBuilder extends DataModelBuilder<Refund> {
  build(context: SerializationContext, map: SerializedData): Refund {
    return Refund.fromMap(context, map);
  }
}
